import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useStyles } from './Expertise.styles'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'

import Secure from 'src/assets/icons/expertise/secure.svg'
import Brain from 'src/assets/icons/expertise/brain.svg'
import Cloud from 'src/assets/icons/expertise/cloud.svg'
import Database from 'src/assets/icons/expertise/database.svg'

const Expertise = () => {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const { t } = useTranslation()

  return (
    <Box className={globalClasses.containerSectionsHome}>
      <Typography className={globalClasses.titleSectionsHome}>
        {t('expertise.title')}
      </Typography>
      <Box className={classes.contentBox}>
        <Box className={classes.cardsGrid}>
          <Box className={classes.card}>
            <img src={Secure} className={classes.icon} />
            <Typography className={classes.title}>
              {t('expertise.data-privacy.title')}
            </Typography>
            <Box className={classes.list}>
              <Typography className={classes.listItem}>
                {t('expertise.data-privacy.list-item1')}
              </Typography>
              <Typography className={classes.listItem}>
                {t('expertise.data-privacy.list-item2')}
              </Typography>
              <Typography className={classes.listItem}>
                {t('expertise.data-privacy.list-item3')}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.card}>
            <img src={Brain} className={classes.icon} />
            <Typography className={classes.title}>
              {t('expertise.machine-learning.title')}
            </Typography>
            <Box className={classes.list}>
              <Typography className={classes.listItem}>
                {t('expertise.machine-learning.list-item1')}
              </Typography>
              <Typography className={classes.listItem}>
                {t('expertise.machine-learning.list-item2')}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.card}>
            <img src={Cloud} className={classes.icon} />
            <Typography className={classes.title}>
              {t('expertise.cloud-computing.title')}
            </Typography>
            <Box className={classes.list}>
              <Typography className={classes.listItem}>
                SaaS / PaaS / IaaS
              </Typography>
              <Typography className={classes.listItem}>
                {t('expertise.cloud-computing.list-item2')}
              </Typography>
              <Typography className={classes.listItem}>
                {t('expertise.cloud-computing.list-item3')}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.card}>
            <img src={Database} className={classes.icon} />
            <Typography className={classes.title}>
              {t('expertise.database.title')}
            </Typography>
            <Box className={classes.list}>
              <Typography className={classes.listItem}>
                {t('expertise.database.list-item1')}
              </Typography>
              <Typography className={classes.listItem}>
                {t('expertise.database.list-item2')}
              </Typography>
              <Typography className={classes.listItem}>
                {t('expertise.database.list-item3')}
              </Typography>
            </Box>
          </Box>

        </Box>
      </Box>
    </Box>
  )
}

export default Expertise
